
webpack.register(
    'modules/live-video-pop-out/channels/channels',
    function() {
        return import('modules/live-video-pop-out/channels/channels');
    },
    true
);